import { examsApi } from "api/examsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useExam = (examId: string | number | undefined) => {
  const queryClient = useQueryClient();
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.SINGLE_EXAM(examId!),
    queryFn: () => examsApi.fetchById(Number(examId)),
    enabled: !!examId,
  });
  const invalidate = () => {
    if (!examId) return;
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SINGLE_EXAM(examId),
    });
  };

  return { invalidate, isLoading, exam: data?.data };
};
